import React, { useState } from 'react';
import logLogo from '../../Assets/Access-Deniednew.png';
import myLogo from '../../Assets/logo.png';
import backgroundImageLight from '../../Assets/login_light.png';
import footerLogo from '../../Assets/slts-logos.gif';
import './login.css';
import { Button, Checkbox, Col, Form, Image, Input, Row, Spin, Typography } from 'antd';
import { Footer, Header } from 'antd/es/layout/layout';
import jwt_decode from "jwt-decode";
import { useNavigate } from 'react-router-dom';
import { errHandler, success } from '../../helper/helper';
import { authentication } from './loginservice';
import { BankOutlined, EyeInvisibleOutlined, EyeTwoTone, LockOutlined, UserOutlined } from "@ant-design/icons";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useAuth } from '../../Auth/AuthProvider';

const Login = () => {
    const { login } = useAuth();
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);
    const handleSubmit = async (values) => {
        const { username, password } = values;
        setLoading(true);


        try {
            const data = { username, password };
            const res = await authentication(data);

            if (res.data) {
                login(res.data);
                success(res.message);

                navigate("/master/reports/deposits", { replace: true });
                // window.location.reload();





            } else {
                errHandler(res);
            }
        } catch (err) {
            errHandler(err);
        } finally {
            setLoading(false);
        }
    };
    const handlePasswordVisibility = () => {
        setIsPasswordVisible((prevState) => !prevState);
    };
    return (
        <div className="login-page border border-black" style={{ backgroundColor: "#f5f5f5" }}>
            <div className="login-container ">
                <Row gutter={16} style={{ width: '100%', height: '100%' }}>
                    {/* Left column for the logo */}
                    <Col xs={24} sm={12} md={12} lg={12} className="login-logo-column">
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                            <Row>
                                <Image src={logLogo} alt="logo" className="log-image" width={200} />
                            </Row>
                            <Row>
                                <h5>Samurdhi Community Base Bank</h5>
                            </Row>

                        </div>
                    </Col>

                    {/* Right column for the login form */}
                    <Col
                        xs={24} sm={12} md={12} lg={12}
                        className="login-form-column"
                        style={{
                            borderLeft: '1px solid #e0e0e0',  // Vertical line between columns
                            paddingLeft: '50px',
                            paddingRight: '50px', // Optional: Adjust padding for spacing
                        }}
                    >
                        <div className="login-panel" style={{ paddingTop: "5px" }}>
                            <Typography.Title level={2} align="start" style={{ color: "#001529" }}>
                                <BankOutlined /> Samurdhi MIS Login
                            </Typography.Title>
                            <p>Please Fill the details bellow.</p>
                            <Form onFinish={handleSubmit} layout={"vertical"} requiredMark={"optional"} style={{ paddingTop: "20px" }}>
                                {/* Username Input */}
                                <Form.Item
                                    name={"username"}
                                    label="Username"
                                    rules={[{ required: true, message: "Please input your username" }]}
                                >
                                    <Input
                                        placeholder="Username"
                                        prefix={<UserOutlined />}
                                        style={{
                                            height: '45px',  // Increase the height of the input
                                            fontSize: '16px'  // Optional: Increase the font size for better visibility
                                        }}
                                    />
                                </Form.Item>

                                {/* Password Input */}
                                <Form.Item
                                    name={"password"}
                                    label="Password"
                                    style={{ paddingTop: "0px" }}
                                    rules={[{ required: true, message: "Please input your password" }]}
                                >
                                    <div style={{ position: 'relative', width: '100%' }}>
                                        <span
                                            style={{
                                                position: 'absolute',
                                                left: '10px',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                fontSize: '16px',
                                                color: '#bfbfbf',
                                            }}
                                        >
                                            <LockOutlined />
                                        </span>

                                        <input
                                            type={isPasswordVisible ? 'text' : 'password'}
                                            placeholder="Password"
                                            style={{
                                                width: '100%',
                                                height: '45px',  // Increase height of the password input
                                                padding: '5px 40px 5px 30px',  // Padding to ensure the icon fits
                                                borderRadius: '4px',
                                                outline: 'none',
                                                fontSize: '16px',  // Larger font size for better visibility
                                            }}
                                        />

                                        <span
                                            onMouseDown={() => setIsPasswordVisible(true)}
                                            onMouseUp={() => setIsPasswordVisible(false)}
                                            onMouseLeave={() => setIsPasswordVisible(false)}
                                            style={{
                                                position: 'absolute',
                                                right: '10px',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                cursor: 'pointer',
                                                fontSize: '16px',
                                                color: '#bfbfbf',
                                            }}
                                        >
                                            {isPasswordVisible ? <FaEyeSlash /> : <FaEye />}
                                        </span>
                                    </div>
                                </Form.Item>

                                {/* Remember Me Checkbox */}
                                <Form.Item>
                                    <Checkbox>Remember Me</Checkbox>
                                </Form.Item>

                                {/* Login Button */}
                                <Col align="start" style={{ marginTop: "10px" }}>
                                    <Button

                                        type="primary"
                                        htmlType="submit"
                                        disabled={loading}
                                        // Large size button
                                        style={{ height: '40px', fontSize: '16px', width: '125px' }}  // Increased button height and font size
                                    >
                                        {loading ? <Spin /> : 'Login'}
                                    </Button>
                                </Col>
                            </Form>


                        </div>
                    </Col>
                </Row>
            </div>

            <Footer align="center">
                <Image src={footerLogo} alt="Logo" className="footer-image" />
            </Footer>
        </div>


    );
};

export default Login;
